import React, { Component } from 'react';
import { Icon, Form, Button, Modal, Dropdown } from 'semantic-ui-react';
import { state } from '../../utils/defaults'

class UpdateAddress extends Component {

    render() {
        return (
            <Modal size="large" open={this.props.open} onClose={this.props.close} closeIcon>
                <Modal.Header><Icon name="edit"></Icon>Update Co-Guarantor {this.props.i + 1} Address</Modal.Header>
                <Modal.Content>
                    <Form className="small">
                        <Form.Group>
                            <Form.Field width={10}>
                                <label>{this.props.t("address.street")}:</label>
                                <Form.Input placeholder={this.props.t("address.street")} value={this.props._ifNull(this.props.address.coaAddress1, "")} name="coaAddress1" onChange={this.props.handleChange(this.props.i)} />
                            </Form.Field>
                            <Form.Field width={6}>
                                <label>Apt / Suite Number:</label>
                                <Form.Input placeholder='Apt / Suite Number' value={this.props._ifNull(this.props.address.coaAddress2, "")} name="coaAddress2" onChange={this.props.handleChange(this.props.i)} />
                            </Form.Field>
                        </Form.Group>
                        <Form.Group>
                            <Form.Field width={6}>
                                <label>Address (PO Box):</label>
                                <Form.Input placeholder='Address (PO Box)' value={this.props._ifNull(this.props.address.coaAddress2, "")} name="coaAddress2" onChange={this.props.handleChange(this.props.i)} />
                            </Form.Field>
                            <Form.Field width={4}>
                                <label>{this.props.t("city")}:</label>
                                <Form.Input placeholder='City' value={this.props._ifNull(this.props.address.coaLocality, "")} name="coaLocality" onChange={this.props.handleChange(this.props.i)} />
                            </Form.Field>
                            <Form.Field width={3}>
                                <label>{this.props.t("state")}:</label>
                                <Dropdown className="fluid" placeholder='Select' search selection options={state} value={this.props._ifNull(this.props.address.coaRegion, "")} name="coaRegion" onChange={this.props.handleChangeSelect(this.props.i)}></Dropdown>
                            </Form.Field>
                            <Form.Field width={3}>
                                <label>{this.props.t("zipcode")}:</label>
                                <Form.Input placeholder={this.props.t("zipcode")} value={this.props._ifNull(this.props.address.coaPostalCode, "")} name="coaPostalCode" onChange={this.props.handleChange(this.props.i)} type="text" maxLength="9" />
                                {this.props.validator.message(this.props.t("zipcode"), this.props.address.coaPostalCode, 'integer', false, { default: 'The Zip code must be a number' })}
                            </Form.Field>
                        </Form.Group>
                    </Form>
                </Modal.Content>
                <Modal.Actions>
                    <Button.Group width={2} className="small buttons">
                        <Button onClick={this.props.close}>{this.props.t("close")}</Button>
                        <Button.Or />
                        <Button positive onClick={this.props.close}>{this.props.t("submit")}</Button>
                    </Button.Group>
                </Modal.Actions>
            </Modal>
        );
    }
}
export default UpdateAddress;


// WEBPACK FOOTER //
// ./src/app/ui/accounts/UpdateAddress.js